const equivalents: Array<Array<string>> = [
  ['a', 'ä'],
  ['o', 'ö'],
  ['u', 'ü'],
  ['ae', 'ä'],
  ['oe', 'ö'],
  ['ue', 'ü'],
  ['ss', 'ß'],
];

equivalents.push(...equivalents.map(([eq1, eq2]) => [eq2, eq1]));

const recursiveCompare = (str1: string, str2: string): boolean => {
  if (str1 === str2) {
    return true;
  }
  if (str1 === '' || str2 === '') {
    return false;
  }
  if (str1[0] === str2[0] && recursiveCompare(str1.slice(1), str2.slice(1))) {
    return true;
  }

  for (const [eq1, eq2] of equivalents) {
    if (
      str1.startsWith(eq1) &&
      str2.startsWith(eq2) &&
      recursiveCompare(str1.slice(eq1.length), str2.slice(eq2.length))
    ) {
      return true;
    }
  }

  return false;
};

const compareGermanStrings = (str1: string, str2: string): boolean => {
  const sanitizedStr1 = str1
    .toLocaleLowerCase()
    .replace(/\s{2,}/g, ' ')
    .trim();
  const sanitizedStr2 = str2
    .toLocaleLowerCase()
    .replace(/\s{2,}/g, ' ')
    .trim();

  return recursiveCompare(sanitizedStr1, sanitizedStr2);
};

export default compareGermanStrings;
